import {
  GET_PLAYER_ANALYSIS_REQUEST,
  GET_PLAYER_ANALYSIS_SUCCESS,
  GET_PLAYER_ANALYSIS_FAILURE,
  CHECK_PLAYER_ANALYSIS_AVAILABILITY_REQUEST,
  CHECK_PLAYER_ANALYSIS_AVAILABILITY_SUCCESS,
  CHECK_PLAYER_ANALYSIS_AVAILABILITY_FAILURE,
  RESET_MATCH_CARD
} from 'Store/constants';

const initialState = {
  data: null,
  loading: false,
  error: null,
  availability: {
    hasAnalysis: false,
    loading: false,
    error: null
  },
  cache: {},
  availabilityCache: {}
};

export default function playerAnalysisReducer (state = initialState, action) {
  switch (action.type) {
    case GET_PLAYER_ANALYSIS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case GET_PLAYER_ANALYSIS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
        cache: {
          ...state.cache,
          [action.eventId]: {
            data: action.payload,
            timestamp: Date.now()
          }
        }
      };

    case GET_PLAYER_ANALYSIS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case CHECK_PLAYER_ANALYSIS_AVAILABILITY_REQUEST:
      return {
        ...state,
        availability: {
          ...state.availability,
          loading: true,
          error: null
        }
      };

    case CHECK_PLAYER_ANALYSIS_AVAILABILITY_SUCCESS:
      return {
        ...state,
        availability: {
          hasAnalysis: action.payload.hasAnalysis,
          loading: false,
          error: null
        },
        availabilityCache: {
          ...state.availabilityCache,
          [action.eventId]: {
            hasAnalysis: action.payload.hasAnalysis,
            data: action.payload.data,
            timestamp: Date.now()
          }
        }
      };

    case CHECK_PLAYER_ANALYSIS_AVAILABILITY_FAILURE:
      return {
        ...state,
        availability: {
          hasAnalysis: false,
          loading: false,
          error: action.payload
        }
      };

    case RESET_MATCH_CARD:
      return initialState;

    default:
      return state;
  }
}
